<template>
  <div class="content">
    <h3 ref="pageHeader" :style="{ '--width': widthVar }" class="pageHeader">仪器设备借用审批</h3>
    <div>
      <el-form :inline="true" :model="formInline" class="demo-form-inline" label-position="left">
        <el-form-item label="组织结构">
          <OrganDialog ref="organDia1" @getSelect="getSelect1" :level="levell" @handleOrganQuery="handleOrganQuery1">
          </OrganDialog>
          <el-input v-model="organLabel" placeholder="请选择所属院系" style="width:320px;" @focus="dialogOpen1"
            @clear="handeleClear1" clearable></el-input>
        </el-form-item>
        <el-form-item label="审批状态">
          <el-select v-model="formInline.status" clearable filterable placeholder="请选择">
            <el-option v-for="item in $store.state.reviewStatus" :key="item.value" :label="item.label"
              :value="item.value"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="申请人姓名">
          <el-input v-model="formInline.user_name" clearable placeholder="请输入姓名"></el-input>
        </el-form-item>
        <el-form-item label="设备名称">
          <el-input v-model="formInline.name" clearable placeholder="请输入设备"></el-input>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="handleQuery">查询</el-button>
        </el-form-item>
      </el-form>
    </div>
    <div>
      <custom-table :data="tableData" border style="width: 100%">
        <custom-table-column fixed label="序号" type="index" width="50">
        </custom-table-column>
        <custom-table-column prop="device_name" fixed label="设备名称" min-width="160px">
        </custom-table-column>
        <custom-table-column prop="username" label="申请人" width="100">
        </custom-table-column>
        <custom-table-column prop="username" label="工号" width="120">
        </custom-table-column>
        <custom-table-column prop="num" label="借用数量" width="100">
        </custom-table-column>
        <custom-table-column prop="status_desc" label="状态" width="80">
        </custom-table-column>
        <custom-table-column prop="review_name" label="审批人" width="100px">
        </custom-table-column>
        <custom-table-column prop="review_desc" label="说明原因" width="160px">
        </custom-table-column>
        <custom-table-column prop="review_time" label="审批时间" width="160px">
        </custom-table-column>
        <custom-table-column prop="start_time" label="借用时间" width="180">
        </custom-table-column>
        <custom-table-column prop="end_time" label="预计归还时间" width="180">
        </custom-table-column>
        <custom-table-column prop="device_model" label="型号" width="160">
          <template slot-scope="scope" v-if="scope.row.device">
            <span>{{ scope.row.device.device_model }}</span>
          </template>
        </custom-table-column>
        <custom-table-column prop="specification" label="规格" width="160">
          <template slot-scope="scope" v-if="scope.row.device">
            <span>{{ scope.row.device.specification }}</span>
          </template>
        </custom-table-column>
        <custom-table-column prop="usage" label="用途" min-width="200px">
        </custom-table-column>
        <custom-table-column prop="created_at" label="申请时间" width="180">
        </custom-table-column>
        <custom-table-column label="操作" fixed="right" width="100">
          <template slot-scope="scope">
            <!-- <el-button v-if="scope.row.status == 'apply'" @click="handleOper(scope.row.id, 'pass')" type="text"
              size="small">审批</el-button> -->
            <el-button v-if="scope.row.status == 1" @click="handleOper(scope.row, 2)" type="text"
              size="small">通过</el-button>
            <el-button v-if="scope.row.status == 1" @click="handleOper(scope.row, 3)" type="text"
              size="small">否决</el-button>
            <el-button v-if="scope.row.status == 2" @click="handleApplyBack(scope.row.id)" type="text"
              size="small">打回</el-button>
          </template>
        </custom-table-column>
      </custom-table>
      <div class="pageLine">
        <PageLine :total='total' ref="pageChild" @getList="getList"></PageLine>
      </div>
    </div>
    <el-dialog :close-on-click-modal="false" :title="title" :visible.sync="centerDialogVisible" width="510px">
      <el-form :model="ruleForm" ref="ruleForm" label-width="100px" class="demo-ruleForm">
        <template v-if="ruleForm.status == 2">
          <el-form-item label="借用数量" prop="num">
            <el-input v-model="ruleForm.num" placeholder="" disabled style="width:336px;"></el-input>
          </el-form-item>
          <el-form-item v-if="ruleForm.status == 2" label="借用设备" prop="individuals"
            :rules="[{ required: true, message: '请选择', trigger: 'change' }]">
            <el-select v-model="ruleForm.individuals" :multiple-limit="ruleForm.num" clearable filter placeholder="请选择"
              multiple style="width:336px;">
              <el-option v-for="(item, index) in eqs" :disabled="item.status != 2" :key="index"
                :label="`${item.serial_no}`" :value="item.id">
                <p>资产编号：{{ item.serial_no }}</p>
                <p v-if="item.status_desc" style=" color: #8492a6; font-size: 13px">状态：{{ item.status_desc }}</p>
                <p v-if="item.training_room" style=" color: #8492a6; font-size: 13px">所属：{{
                  item.training_room.training_name }}</p>
              </el-option>
            </el-select>
          </el-form-item>
        </template>
        <el-form-item v-if="ruleForm.status == 3" label="说明原因" prop="review_desc"
          :rules="[{ required: true, message: '请输入', trigger: 'blur' }]">
          <el-input type="textarea" placeholder="请输入" :rows="4" v-model="ruleForm.review_desc"
            style="width:336px;"></el-input>
        </el-form-item>
        <el-form-item style="margin-top:8px;width:100%;text-align:right;">
          <el-button type="primary" @click="submitFormByFun('ruleForm', setStatus)">提交</el-button>
          <el-button @click="resetForm('ruleForm')" style="margin-right:24px;">重置</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>
    <el-dialog :close-on-click-modal="false" title="提示" :visible.sync="dialogVisible" width="400px">
      <span>是否删除</span>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="deleteDeviceInto">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { mixinList } from '@/assets/js/mixin/list';
import { mixinOrgan } from '@/assets/js/mixin/organization';
import { mixinFormatter } from '@/assets/js/mixin/formatter';

export default {
  name: 'equipmentInto',
  mixins: [mixinList, mixinOrgan, mixinFormatter],
  data() {
    return {
      formInline: {
        user_name: '',
        name: '',
        structure_1: '',
        major: '',
        status: ''
      },
      levell: [1, 2],
      centerDialogVisible: false,
      eqs: [],
      ruleForm: {
        status: '',
        review_desc: '',
        individuals: []
      },
    };
  },
  components: {},
  created() { },
  mounted() {
    // this.getStudentApply()
    // this.getProvince()
    // this.$store.dispatch('getTarinMent', { type: 'all' });
  },
  methods: {
    handleOper(row, status) {
      this.title = '通过';
      if (status == 3) {
        this.title = '否决';
      } else {
        this.getEqs(row.device_id)
      }
      this.centerDialogVisible = true;
      this.ruleForm.status = status;
      this.ruleForm.num = row.num;
      this.ruleForm.id = row.id;
      this.ruleForm.individuals = [];
    },
    handleApplyBack(id) {
      this.confirmBox('warning', `此操作将打回该申请，是否继续`, { id }, this.backMethod);
    },
    async backMethod(params) {
      let res = await this.$api.instance.interfaceServer(`api/new_device/borrow/rollback/${params.id}`, 'post', params);
      if (res.code == 0) {
        this.$message({
          type: 'success',
          center: true,
          message: '打回成功！',
        });
        this.handleQuery();
      }
    },
    async getEqs(id) {
      let res = await this.$api.instance.interfaceServer(`api/new_device/individual/list`, 'get', { device_id: id, page: 1, size: 9999 });
      if (res.code == 0 && res.data) {
        this.eqs = res.data.data
      }
    },
    async setStatus() {
      let res = await this.$api.instance.interfaceServer(`api/new_device/borrow/review/${this.ruleForm.id}`, 'post', this.ruleForm);
      if (res.code == 0) {
        this.$message({
          type: 'success',
          center: true,
          message: '处理成功！',
        });
        this.centerDialogVisible = false
        this.getList();
      }
    },
    async handleClassChange(e) {
      if (this.ruleForm.training_room_id) {
        let params = { training_room_id: this.ruleForm.training_room_id };
        params.page = 1;
        params.size = 9999;
        let res = await this.$api.instance.interfaceServer('api/training/common/room/device/list', 'get', params);
        if (res.code == 0 && res.data) {
          this.eqs = res.data.data;
        }
      } else {
        this.eq = [];
      }
    },
    onSubmit() {
      console.log('submit!');
    },
    handleSet() {
      this.centerDialogVisible = true;
    },
    handleClick() {
      this.centerDialogVisible = true;
    },
    async deleteDeviceInto() {
      let params = { id: this.delid };
      let res = await this.$api.delet.deleteDeviceScrap(params);
      if (res.code == 0) {
        this.$message({
          type: 'success',
          center: true,
          message: '删除成功！',
        });
        this.dialogVisible = false;
        this.handleQuery();
      }
    },
    async createDeviceInto() {
      let params = this.$until.deleteNullPrototype(this.ruleForm);
      params.items = params.items.map((item) => {
        return {
          type: item.type,
          name: item.name,
          num: item.num,
          id: item.id,
        };
      });
      params.items = JSON.stringify(params.items);
      let res = await this.$api.instance.interfaceServer('api/open_reservation/apply/add', 'post', params);
      if (res.code == 0) {
        this.$message({
          type: 'success',
          center: true,
          message: '提交成功！',
        });
        this.clearState();
      }
    },
    // async updateJournalOfTearcher() {
    //   let params = this.$until.easyDeepCopy(this.ruleForm);;
    //   let res = await this.$api.update.updateJournalOfTearcher(params);
    //   if (res.code == 0) {
    //     this.$message({
    //       type: 'success',
    //       center: true,
    //       message: '编辑成功！',
    //     });
    //     this.clearState();
    //   }
    // },
    async getList() {
      let params = this.$until.deleteNullPrototype(this.formInline);
      params.page = this.$refs.pageChild.page;
      params.size = this.$refs.pageChild.size;
      let res = await this.$api.instance.interfaceServer('api/new_device/borrow/list', 'get', params);
      if (res.code == 0 && res.data) {
        this.tableData = res.data.data;
        this.total = res.data.total;
      }
    },
    handleQuery() {
      this.beforeQueryByKey("structure_1", "structure_2")
      this.$refs.pageChild.page = 1;
      this.getList();
    },
    resetForm(formName) {
      this.ruleForm.device_price = 0;
      this.remainder_quantity = 0;
      this.$refs[formName].resetFields();
    },
    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          // if (this.type == 'add') {
          this.createDeviceInto();
          // }else if(this.type == 'edit'){
          //   this.updateJournalOfTearcher()
          // }
        } else {
          // console.log('error submit!!');
          return false;
        }
      });
    },
  },
};
</script>
<style lang="less" scoped>
.pageHeader:before {
  width: var(--width);
}

.el-select-dropdown__item {
  height: auto !important;
  line-height: 20px;
  padding: 4px 30px;
}
</style>
